/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

import Checkbox from '../../../Form/Checkbox';

import imageModifier from '../../../../utils/imageModifier';
import SingleObjUploaderWithSelector from '../../Mam/SingleObjUploaderWithSelector';
import Modal from '../../../Modal/Modal';


const PdfModule = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialStateMediaDesc = {
    type: 'Pdf',
    url: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    poster: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    fileReadableName: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialStateMediaDesc);
  const [isModalOn, setModalState] = useState(false);
  const [activeLang, setActiveLanguage] = useState('');
  const [imageObj, setimageObj] = useState({});
  const [pdfObj, setPdfObj] = useState({});
  const [isChoosingImage, setChooseImage] = useState(false);
  const [isChoosingPdf, setChoosePdf] = useState(false);
  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {
        setState(component);
      } else {
        const componentObj = {
          id,
          component: state,
        };
        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  const toggleModal = (lang) => {
    setActiveLanguage(lang);
    setModalState(!isModalOn);
  };

  const setImage = ([obj]) => {
    toggleModal();
    setChooseImage(false);
    setimageObj(obj);
    const { component } = components[index];

    const comp = {
      ...component,
      poster: {
        ...component.poster,
        [activeLang.toLowerCase()]: obj.url,
      },
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  const setPdf = ([obj]) => {
    console.log(obj);
    toggleModal();
    setChoosePdf(false);
    setPdfObj(obj);
    const { component } = components[index];

    const comp = {
      ...component,
      fileReadableName: {
        ...component.fileReadableName,
        [activeLanguage.toLowerCase()]: obj.description[activeLanguage.toLowerCase()],
      },
      url: {
        ...component.url,
        [activeLanguage.toLowerCase()]: obj.url,
      },
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  const pdfName = state.url[activeLanguage].split('https://assets.primaverasound.com/psweb/')[1];

  return (
    <>
      {languages.map(lang => (
        <div key={lang} className={`w-full ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'}`}>
          <div className="bg-greyFilter py-2 pl-16 rounded-lg flex flex-row">
            <div className="flex flex-col items-center w-1/2 justify-center">
              <button className="font-americaMonoBold text-xs px-6 py-2 mt-3 -mb-1 rounded-full uppercase bg-black text-white flex flex-row items-center" type="button" onClick={() => { setChooseImage(true); toggleModal(activeLanguage); setChoosePdf(false); }}>
                {state && state.hasOwnProperty('poster') && state.poster[activeLanguage] ? 'Change image' : 'Select image'}
                {state && state.hasOwnProperty('poster') && state.poster[activeLanguage] ? <span className="font-icon icon-loading-arrows text-sm pl-2 text-white" /> : <span className="font-icon icon-add-button text-base text-white font-bold pl-2" />}
              </button>
              <div className="rounded-tr-lg rounded-tl-xl">
                <div className="image pt-3 pb-1">
                  {state.poster[activeLanguage] && <img src={imageModifier(state.poster[activeLanguage], '100x100')} alt="img" className="rounded" />}
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center w-1/2 justify-center">
              <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-black text-white flex flex-row items-center" type="button" onClick={() => { setChoosePdf(true); toggleModal(activeLanguage); setChooseImage(false); }}>
                {state && state.hasOwnProperty('poster') && state.poster[activeLanguage] ? 'Change pdf' : 'Select pdf'}
                {state && state.hasOwnProperty('poster') && state.poster[activeLanguage] ? <span className="font-icon icon-loading-arrows text-sm pl-2 text-white" /> : <span className="font-icon icon-add-button text-base text-white font-bold pl-2" />}
              </button>
              <div className="">
                {state.url[activeLanguage]
              && (
              <div>
                <span className="font-icon icon-file text-52 flex justify-center items-center h-100px" />
                <span className="uppercase text-sm font-americaMonoRegular"><a href={`${state.url[activeLanguage]}`} target="_blank" rel="noopener noreferrer" className="text-white hover:text-white">{pdfName}</a></span>
              </div>
              )}
              </div>
            </div>
          </div>
        </div>
      ))}
      {isModalOn && (
        <Modal handleClick={toggleModal} positionMiddle zIndex="5" singleUploader>
          {isChoosingImage && <SingleObjUploaderWithSelector selectCallback={setImage} />}
          {isChoosingPdf && <SingleObjUploaderWithSelector selectCallback={setPdf} />}
        </Modal>
      )}
    </>
  );
};

PdfModule.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
};
PdfModule.defaultProps = {
  reusableComponent: null,
};

export default PdfModule;
